import { AcuseRecibo } from "./AcuseRecibo";

export class AcuseReciboMasivo {
   emisorId: string;
   usuarioId: string;
   replySendModels: AcuseRecibo[];
}
